import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    // name: 'intro',
    // component: () => import('../components/Intro.vue')
    component: () => import('../components/Home.vue'),
    meta: { showSidebar: false } // 默认显示侧边栏
  },
  {
    path: '/intro',
    name: 'intro',
    component: () => import('../components/Intro.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../components/Home.vue')
  },
  {
    path: '/product/Streaming', // 修改路径
    name: 'Streaming',
    component: () => import('../components/product/Streaming.vue'),
    meta: { showSidebar: false }
  },{
    path: '/product/SubAccount', // 修改路径
    name: 'SubAccount',
    component: () => import('../components/product/SubAccount.vue'),
    meta: { showSidebar: false }
  },{
    path: '/product/Polymerization', // 修改路径
    name: 'Polymerization',
    component: () => import('../components/product/Polymerization.vue'),
    meta: { showSidebar: false }
  },{
    path: '/scheme/Commerce', // 修改路径
    name: 'Commerce',
    component: () => import('../components/scheme/Commerce.vue'),
    meta: { showSidebar: false }
  },{
    path: '/scheme/Property', // 修改路径
    name: 'Property',
    component: () => import('../components/scheme/Property.vue'),
    meta: { showSidebar: false }
  },{
    path: '/scheme/SupplyChain', // 修改路径
    name: 'SupplyChain',
    component: () => import('../components/scheme/SupplyChain.vue'),
    meta: { showSidebar: false }
  },{
    path: '/scheme/Case', // 案例
    name: 'Case',
    component: () => import('../components/scheme/Case.vue'),
    meta: { showSidebar: false }
  },{
    path: '/scheme/ServeSupport', // 服务与支持
    name: 'ServeSupport',
    component: () => import('../components/scheme/ServeSupport.vue'),
    meta: { showSidebar: false }
  },{
    path: '/centre/Developer', // 开发者中心
    name: 'Developer',
    component: () => import('../components/centre/Developer.vue'),
    meta: { showSidebar: false }
  },{
    path: '/centre/Assist', // 帮助中心
    name: 'Assist',
    component: () => import('../components/centre/Assist.vue'),
    meta: { showSidebar: false }
  },{
    path: '/centre/Fingerpost', // 开发者指南
    name: 'Fingerpost',
    component: () => import('../components/centre/Fingerpost.vue'),
    meta: { showSidebar: false }
  },{
    path: '/centre/Sdk', // 开发者指南
    name: 'Sdk',
    component: () => import('../components/centre/Sdk.vue'),
    meta: { showSidebar: false }
  },{
    path: '/centre/System', // 系统状态
    name: 'System',
    component: () => import('../components/centre/System.vue'),
    meta: { showSidebar: false }
  },
  // 前言
  {
    path: '/introduction1',
    name: 'introduction1',
    component: () => import('../components/introduction/introduction1.vue')
  },
  {
    path: '/introduction2',
    name: 'introduction2',
    component: () => import('../components/introduction/introduction2.vue')
  },
  // {
  //   path: '/introduction3',
  //   name: 'introduction3',
  //   component: () => import('../components/introduction/introduction3.vue')
  // },
  {
    path: '/introduction4',
    name: 'introduction4',
    component: () => import('../components/introduction/introduction4.vue')
  },
  // {
  //   path: '/introduction5',
  //   name: 'introduction5',
  //   component: () => import('../components/introduction/introduction5.vue')
  // },
  {
    path: '/payCreate',
    name: 'payCreate',
    component: () => import('../components/pay/Create.vue')
  },
  {
    path: '/paySurvey',
    name: 'paySurvey',
    component: () => import('../components/pay/Survey.vue')
  },
  {
    path: '/payCancel',
    name: 'payCancel',
    component: () => import('../components/pay/Cancel.vue')
  },
  {
    path: '/payQuery',
    name: 'payQuery',
    component: () => import('../components/pay/Query.vue')
  },
  {
    path: '/payWaivePayment',
    name: 'payWaivePayment',
    component: () => import('../components/pay/WaivePayment.vue')
  },
  {
    path: '/payQueryList',
    name: 'payQueryList',
    component: () => import('../components/pay/QueryList.vue')
  },
  {
    path: '/payEvent',
    name: 'payEvent',
    component: () => import('../components/pay/Event.vue')
  },
  // {
  //   path: '/payAffirm',
  //   name: 'payAffirm',
  //   component: () => import('../components/pay/Affirm.vue')
  // },
  {
    path: '/refundSurvey',
    name: 'refundSurvey',
    component: () => import('../components/refund/Survey.vue')
  },
  {
    path: '/refundCreate',
    name: 'refundCreate',
    component: () => import('../components/refund/Create.vue')
  },
  {
    path: '/refundQuery',
    name: 'refundQuery',
    component: () => import('../components/refund/Query.vue')
  },
  {
    path: '/refundQueryList',
    name: 'refundQueryList',
    component: () => import('../components/refund/QueryList.vue')
  },
  {
    path: '/refundEvent',
    name: 'refundEvent',
    component: () => import('../components/refund/Event.vue')
  },
  {
    path: '/batchRefundSurvey',
    name: 'batchRefundSurvey',
    component: () => import('../components/batchRefund/Survey.vue')
  },
  {
    path: '/batchRefundCreate',
    name: 'batchRefundCreate',
    component: () => import('../components/batchRefund/Create.vue')
  },
  {
    path: '/batchRefundQuery',
    name: 'batchRefundQuery',
    component: () => import('../components/batchRefund/Query.vue')
  },
  {
    path: '/batchRefundQueryList',
    name: 'batchRefundQueryList',
    component: () => import('../components/batchRefund/QueryList.vue')
  },
  {
    path: '/batchRefundEvent',
    name: 'batchRefundEvent',
    component: () => import('../components/batchRefund/Event.vue')
  },
  {
    path: '/businessPaySurvey',
    name: 'businessPaySurvey',
    component: () => import('../components/businessPay/Survey.vue')
  },
  {
    path: '/businessPayCreate',
    name: 'businessPayCreate',
    component: () => import('../components/businessPay/Create.vue')
  },
  {
    path: '/businessPayQuery',
    name: 'businessPayQuery',
    component: () => import('../components/businessPay/Query.vue')
  },
  {
    path: '/businessPayQueryList',
    name: 'businessPayQueryList',
    component: () => import('../components/businessPay/QueryList.vue')
  },
  {
    path: '/businessPayEvent',
    name: 'businessPayEvent',
    component: () => import('../components/businessPay/Event.vue')
  },
  {
    path: '/batchBusinessPaySurvey',
    name: 'batchBusinessPaySurvey',
    component: () => import('../components/batchBusinessPay/Survey.vue')
  },
  {
    path: '/batchBusinessPayCreate',
    name: 'batchBusinessPayCreate',
    component: () => import('../components/batchBusinessPay/Create.vue')
  },
  {
    path: '/batchBusinessPayQuery',
    name: 'batchBusinessPayQuery',
    component: () => import('../components/batchBusinessPay/Query.vue')
  },
  {
    path: '/batchBusinessPayQueryList',
    name: 'batchBusinessPayQueryList',
    component: () => import('../components/batchBusinessPay/QueryList.vue')
  },
  {
    path: '/batchbusinessPayEvent',
    name: 'batchbusinessPayEvent',
    component: () => import('../components/batchBusinessPay/Event.vue')
  },
  {
    path: '/redEnvelopesSurvey',
    name: 'redEnvelopesSurvey',
    component: () => import('../components/redEnvelopes/Survey.vue')
  },
  {
    path: '/redEnvelopesCreate',
    name: 'redEnvelopesCreate',
    component: () => import('../components/redEnvelopes/Create.vue')
  },
  {
    path: '/redEnvelopesQuery',
    name: 'redEnvelopesQuery',
    component: () => import('../components/redEnvelopes/Query.vue')
  },
  {
    path: '/redEnvelopesQueryList',
    name: 'redEnvelopesQueryList',
    component: () => import('../components/redEnvelopes/QueryList.vue')
  },
  {
    path: '/redEnvelopesEvent',
    name: 'redEnvelopesEvent',
    component: () => import('../components/redEnvelopes/Event.vue')
  },
  {
    path: '/usersSurvey',
    name: 'usersSurvey',
    component: () => import('../components/users/Survey.vue')
  },
  {
    path: '/usersCreate',
    name: 'redEnvelopesCreate',
    component: () => import('../components/users/Create.vue')
  },
  {
    path: '/usersQuery',
    name: 'redEnvelopesQuery',
    component: () => import('../components/users/Query.vue')
  },
  {
    path: '/usersQueryList',
    name: 'redEnvelopesQueryList',
    component: () => import('../components/users/QueryList.vue')
  },
  {
    path: '/usersUpdate',
    name: 'usersUpdate',
    component: () => import('../components/users/Update.vue')
  },
  {
    path: '/settleAccountsSurvey',
    name: 'settleAccountsSurvey',
    component: () => import('../components/settleAccounts/Survey.vue')
  },
  {
    path: '/settleAccountsCreate',
    name: 'settleAccountsCreate',
    component: () => import('../components/settleAccounts/Create.vue')
  },
  {
    path: '/settleAccountsQuery',
    name: 'settleAccountsQuery',
    component: () => import('../components/settleAccounts/Query.vue')
  },
  {
    path: '/settleAccountsQueryList',
    name: 'settleAccountsQueryList',
    component: () => import('../components/settleAccounts/QueryList.vue')
  },
  {
    path: '/settleAccountsDel',
    name: 'settleAccountsDel',
    component: () => import('../components/settleAccounts/Del.vue')
  },
  {
    path: '/ordersSurvey',
    name: 'ordersSurvey',
    component: () => import('../components/orders/Survey.vue')
  },
  {
    path: '/ordersCreate',
    name: 'ordersCreate',
    component: () => import('../components/orders/Create.vue')
  },
  {
    path: '/ordersPay',
    name: 'ordersPay',
    component: () => import('../components/orders/Pay.vue')
  },
  {
    path: '/ordersCancelOrUpdate',
    name: 'ordersCancelOrUpdate',
    component: () => import('../components/orders/CancelOrUpdate.vue')
  },
  {
    path: '/ordersQuery',
    name: 'ordersQuery',
    component: () => import('../components/orders/Query.vue')
  },
  {
    path: '/ordersQueryList',
    name: 'orderQueryList',
    component: () => import('../components/orders/QueryList.vue')
  },
  {
    path: '/ordersQueryObj',
    name: 'ordersQueryObj',
    component: () => import('../components/orders/QueryObj.vue')
  },
  {
    path: '/ordersQueryObjList',
    name: 'ordersQueryObjList',
    component: () => import('../components/orders/QueryObjList.vue')
  },
  {
    path: '/ordersEvent',
    name: 'ordersEvent',
    component: () => import('../components/orders/Event.vue')
  },
  {
    path: '/ordersRefundSurvey',
    name: 'ordersRefundSurvey',
    component: () => import('../components/ordersRefunds/Survey.vue')
  },
  {
    path: '/ordersRefundCreate',
    name: 'ordersRefundCreate',
    component: () => import('../components/ordersRefunds/Create.vue')
  },
  {
    path: '/ordersRefundQuery',
    name: 'ordersRefundQuery',
    component: () => import('../components/ordersRefunds/Query.vue')
  },
  {
    path: '/ordersRefundEvent',
    name: 'ordersRefundEvent',
    component: () => import('../components/ordersRefunds/Event.vue')
  },
  {
    path: '/ordersRefundQueryList',
    name: 'ordersRefundQueryList',
    component: () => import('../components/ordersRefunds/QueryList.vue')
  },
  {
    path: '/rechargesSurvey',
    name: 'rechargesSurvey',
    component: () => import('../components/recharges/Survey.vue')
  },
  {
    path: '/rechargesCreate',
    name: 'rechargesCreate',
    component: () => import('../components/recharges/Create.vue')
  },
  {
    path: '/rechargesQuery',
    name: 'rechargesQuery',
    component: () => import('../components/recharges/Query.vue')
  },
  {
    path: '/rechargesEvent',
    name: 'rechargesEvent',
    component: () => import('../components/recharges/Event.vue')
  },
  {
    path: '/rechargesQueryList',
    name: 'rechargesQueryList',
    component: () => import('../components/recharges/QueryList.vue')
  },
  {
    path: '/rechargesRefundsSurvey',
    name: 'rechargesRefundsSurvey',
    component: () => import('../components/rechargesRefunds/Survey.vue')
  },
  {
    path: '/rechargesRefundsCreate',
    name: 'rechargesRefundsCreate',
    component: () => import('../components/rechargesRefunds/Create.vue')
  },
  {
    path: '/rechargesRefundsQuery',
    name: 'rechargesRefundsQuery',
    component: () => import('../components/rechargesRefunds/Query.vue')
  },
  {
    path: '/rechargesRefundsEvent',
    name: 'rechargesRefundsEvent',
    component: () => import('../components/rechargesRefunds/Event.vue')
  },
  {
    path: '/rechargesRefundsQueryList',
    name: 'rechargesRefundsQueryList',
    component: () => import('../components/rechargesRefunds/QueryList.vue')
  },
  {
    path: '/withdrawalsSurvey',
    name: 'withdrawalsSurvey',
    component: () => import('../components/withdrawals/Survey.vue')
  },
  {
    path: '/withdrawalsCreate',
    name: 'withdrawalsCreate',
    component: () => import('../components/withdrawals/Create.vue')
  },
  {
    path: '/withdrawalsUpdate',
    name: 'withdrawalsUpdate',
    component: () => import('../components/withdrawals/Update.vue')
  },
  {
    path: '/withdrawalsQuery',
    name: 'withdrawalsQuery',
    component: () => import('../components/withdrawals/Query.vue')
  },
  {
    path: '/withdrawalsEvent',
    name: 'withdrawalsEvent',
    component: () => import('../components/withdrawals/Event.vue')
  },
  {
    path: '/withdrawalsQueryList',
    name: 'withdrawalsQueryList',
    component: () => import('../components/withdrawals/QueryList.vue')
  },
  {
    path: '/batchWithdrawalsSurvey',
    name: 'batchWithdrawalsSurvey',
    component: () => import('../components/batchWithdrawals/Survey.vue')
  },
  {
    path: '/batchWithdrawalsCreate',
    name: 'batchWithdrawalsCreate',
    component: () => import('../components/batchWithdrawals/Create.vue')
  },
  {
    path: '/batchWithdrawalsQuery',
    name: 'batchWithdrawalsQuery',
    component: () => import('../components/batchWithdrawals/Query.vue')
  },
  {
    path: '/batchWithdrawalsEvent',
    name: 'batchWithdrawalsEvent',
    component: () => import('../components/batchWithdrawals/Event.vue')
  },
  {
    path: '/batchWithdrawalsQueryList',
    name: 'batchWithdrawalsQueryList',
    component: () => import('../components/batchWithdrawals/QueryList.vue')
  },
  {
    path: '/balanceBonusesSurvey',
    name: 'balanceBonusesSurvey',
    component: () => import('../components/balanceBonuses/Survey.vue')
  },
  {
    path: '/balanceBonusesCreate',
    name: 'balanceBonusesCreate',
    component: () => import('../components/balanceBonuses/Create.vue')
  },
  {
    path: '/balanceBonusesQuery',
    name: 'balanceBonusesQuery',
    component: () => import('../components/balanceBonuses/Query.vue')
  },
  {
    path: '/balanceBonusesQueryList',
    name: 'balanceBonusesQueryList',
    component: () => import('../components/balanceBonuses/QueryList.vue')
  },
  {
    path: '/balanceTransfersSurvey',
    name: 'balanceTransfersSurvey',
    component: () => import('../components/balanceTransfers/Survey.vue')
  },
  {
    path: '/balanceTransfersCreate',
    name: 'balanceTransfersCreate',
    component: () => import('../components/balanceTransfers/Create.vue')
  },
  {
    path: '/balanceTransfersQuery',
    name: 'balanceTransfersQuery',
    component: () => import('../components/balanceTransfers/Query.vue')
  },
  {
    path: '/balanceTransfersQueryList',
    name: 'balanceTransfersQueryList',
    component: () => import('../components/balanceTransfers/QueryList.vue')
  },
  {
    path: '/balanceSettlementsSurvey',
    name: 'balanceSettlementsSurvey',
    component: () => import('../components/balanceSettlements/Survey.vue')
  },
  {
    path: '/balanceSettlementsQuery',
    name: 'balanceSettlementsQuery',
    component: () => import('../components/balanceSettlements/Query.vue')
  },
  {
    path: '/balanceSettlementsQueryList',
    name: 'balanceSettlementsQueryList',
    component: () => import('../components/balanceSettlements/QueryList.vue')
  },
  {
    path: '/balanceTransactionsSurvey',
    name: 'balanceTransactionsSurvey',
    component: () => import('../components/balanceTransactions/Survey.vue')
  },
  {
    path: '/balanceTransactionsQuery',
    name: 'balanceTransactionsQuery',
    component: () => import('../components/balanceTransactions/Query.vue')
  },
  {
    path: '/balanceTransactionsQueryList',
    name: 'balanceTransactionsQueryList',
    component: () => import('../components/balanceTransactions/QueryList.vue')
  },
  // 优惠券
  // Coupon Templates
  {
    path: '/couponTemplatesSurvey',
    name: 'couponTemplatesSurvey',
    component: () => import('../components/couponTemplates/Survey.vue')
  },
  {
    path: '/couponTemplatesCreate',
    name: 'couponTemplatesCreate',
    component: () => import('../components/couponTemplates/Create.vue')
  },
  {
    path: '/couponTemplatesQuery',
    name: 'couponTemplatesQuery',
    component: () => import('../components/couponTemplates/Query.vue')
  },
  {
    path: '/couponTemplatesQueryList',
    name: 'couponTemplatesQueryList',
    component: () => import('../components/couponTemplates/QueryList.vue')
  },
  {
    path: '/couponTemplatesUpdate',
    name: 'couponTemplatesUpdate',
    component: () => import('../components/couponTemplates/Update.vue')
  },
  {
    path: '/couponTemplatesDel',
    name: 'couponTemplatesDel',
    component: () => import('../components/couponTemplates/Del.vue')
  },
  // Coupon
  {
    path: '/couponSurvey',
    name: 'couponSurvey',
    component: () => import('../components/coupon/Survey.vue')
  },
  {
    path: '/couponCreate',
    name: 'couponCreate',
    component: () => import('../components/coupon/Create.vue')
  },
  {
    path: '/batchCouponCreate',
    name: 'batchCouponCreate',
    component: () => import('../components/coupon/BatchCreate.vue')
  },
  {
    path: '/couponQuery',
    name: 'couponQuery',
    component: () => import('../components/coupon/Query.vue')
  },
  {
    path: '/couponUserQueryList',
    name: 'couponUserQueryList',
    component: () => import('../components/coupon/UserQueryList.vue')
  },
  {
    path: '/couponQueryList',
    name: 'couponQueryList',
    component: () => import('../components/coupon/QueryList.vue')
  },
  {
    path: '/couponUpdate',
    name: 'couponUpdate',
    component: () => import('../components/coupon/Update.vue')
  },
  {
    path: '/couponDel',
    name: 'couponDel',
    component: () => import('../components/coupon/Del.vue')
  },
  // 商户层级
  // Sub Apps子商户应用
  {
    path: '/subAppsSurvey',
    name: 'subAppsSurvey',
    component: () => import('../components/subApps/Survey.vue')
  },
  {
    path: '/subAppsCreate',
    name: 'subAppsCreate',
    component: () => import('../components/subApps/Create.vue')
  },
  {
    path: '/subAppsQuery',
    name: 'subAppsQuery',
    component: () => import('../components/subApps/Query.vue')
  },
  {
    path: '/subAppsUpdate',
    name: 'subAppsUpdate',
    component: () => import('../components/subApps/Update.vue')
  },
  {
    path: '/subAppsDel',
    name: 'subAppsDel',
    component: () => import('../components/subApps/Del.vue')
  },
  {
    path: '/subAppsQueryList',
    name: 'subAppsQueryList',
    component: () => import('../components/subApps/QueryList.vue')
  },
  // Channels 子商户渠道参数
  {
    path: '/channelsSurvey',
    name: 'channelsSurvey',
    component: () => import('../components/channels/Survey.vue')
  },
  {
    path: '/channelsCreate',
    name: 'channelsCreate',
    component: () => import('../components/channels/Create.vue')
  },
  {
    path: '/channelsQuery',
    name: 'channelsQuery',
    component: () => import('../components/channels/Query.vue')
  },
  {
    path: '/channelsUpdate',
    name: 'channelsUpdate',
    component: () => import('../components/channels/Update.vue')
  },
  {
    path: '/channelsDel',
    name: 'channelsDel',
    component: () => import('../components/channels/Del.vue')
  },
  // 分润
  // Royalties分润
  {
    path: '/royaltySurvey',
    name: 'royaltySurvey',
    component: () => import('../components/royalty/Survey.vue')
  },
  {
    path: '/royaltyBatchUpdate',
    name: 'royaltyBatchUpdate',
    component: () => import('../components/royalty/BatchUpdate.vue')
  },
  {
    path: '/royaltyQuery',
    name: 'royaltyQuery',
    component: () => import('../components/royalty/Query.vue')
  },
  {
    path: '/royaltyQueryList',
    name: 'royaltyQueryList',
    component: () => import('../components/royalty/QueryList.vue')
  },
  // Royalty Templates分润模板
  {
    path: '/royaltyTemplatesSurvey',
    name: 'royaltyTemplatesSurvey',
    component: () => import('../components/royaltyTemplates/Survey.vue')
  },
  {
    path: '/royaltyTemplatesCreate',
    name: 'royaltyTemplatesCreate',
    component: () => import('../components/royaltyTemplates/Create.vue')
  },
  {
    path: '/royaltyTemplatesQuery',
    name: 'royaltyTemplatesQuery',
    component: () => import('../components/royaltyTemplates/Query.vue')
  },
  {
    path: '/royaltyTemplatesQueryList',
    name: 'royaltyTemplatesQueryList',
    component: () => import('../components/royaltyTemplates/QueryList.vue')
  },
  {
    path: '/royaltyTemplatesUpdate',
    name: 'royaltyTemplatesUpdate',
    component: () => import('../components/royaltyTemplates/Update.vue')
  },
  {
    path: '/royaltyTemplatesDel',
    name: 'royaltyTemplatesDel',
    component: () => import('../components/royaltyTemplates/Del.vue')
  },
  // Royalty Settlements分润结算
  {
    path: '/royaltySettlementsSurvey',
    name: 'royaltySettlementsSurvey',
    component: () => import('../components/royaltySettlements/Survey.vue')
  },
  {
    path: '/royaltySettlementsCreate',
    name: 'royaltySettlementsCreate',
    component: () => import('../components/royaltySettlements/Create.vue')
  },
  {
    path: '/royaltySettlementsQuery',
    name: 'royaltySettlementsQuery',
    component: () => import('../components/royaltySettlements/Query.vue')
  },
  {
    path: '/royaltySettlementsUpdate',
    name: 'royaltySettlementsUpdate',
    component: () => import('../components/royaltySettlements/Update.vue')
  },
  {
    path: '/royaltySettlementsQueryList',
    name: 'royaltySettlementsQueryList',
    component: () => import('../components/royaltySettlements/QueryList.vue')
  },
  // Royalty Transactions分润结算明细
  {
    path: '/royaltyTransactionsSurvey',
    name: 'royaltyTransactionsSurvey',
    component: () => import('../components/royaltyTransactions/Survey.vue')
  },
  {
    path: '/royaltyTransactionsQuery',
    name: 'royaltyTransactionsQuery',
    component: () => import('../components/royaltyTransactions/Query.vue')
  },
  {
    path: '/royaltyTransactionsQueryList',
    name: 'royaltyTransactionsQueryList',
    component: () => import('../components/royaltyTransactions/QueryList.vue')
  },
  {
    path: '/royaltyTransactionsEvent',
    name: 'royaltyTransactionsEvent',
    component: () => import('../components/royaltyTransactions/Event.vue')
  },
  // 辅助接口
  {
    path: '/cardSurvey',
    name: 'cardSurvey',
    component: () => import('../components/card/Survey.vue')
  },
  {
    path: '/cardAuth',
    name: 'cardAuth',
    component: () => import('../components/card/Auth.vue')
  },
  // webhooks回调
  {
    path: '/webhooksSurvey',
    name: 'webhooksSurvey',
    component: () => import('../components/webHooks/Survey.vue')
  },
  {
    path: '/webhooksEvent',
    name: 'webhooksEvent',
    component: () => import('../components/webHooks/Event.vue')
  },
  {
    path: '/webhooksEventQuery',
    name: 'webhooksEventQuery',
    component: () => import('../components/webHooks/EventQuery.vue')
  },
  // 更新日志
  {
    path: '/apiLog',
    name: 'apiLog',
    component: () => import('../components/ApiLog/Log.vue')
  },
  // 附录
  {
    path: '/appendix1',
    name: 'appendix1',
    component: () => import('../components/appendix/appendix1.vue')
  },
  {
    path: '/appendix2',
    name: 'appendix2',
    component: () => import('../components/appendix/appendix2.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/apidoc/',
  routes
})

export default router
